import React, { useEffect, useMemo, useState } from 'react';

import useMediaQuery from 'utils/useMediaQuery';
import { ListItemProps } from 'components/List/ListItem';
import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';

import { WrappedList } from '../WrappedList';

import styles from './CarInfo.module.scss';

interface ICarInfo {
  carInfoItems: Array<ListItemProps>;
}

export const CarInfo: React.VFC<ICarInfo> = ({ carInfoItems }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isOpen, setIsOpen] = useState(false);
  const [infoItems, setInfoItems] = useState<ListItemProps[]>();

  const listItemsPaginated = useMemo(
    () => carInfoItems.slice(0, isMobile ? 6 : 12),
    [carInfoItems, isMobile]
  );

  useEffect(() => {
    setInfoItems(listItemsPaginated);
  }, [listItemsPaginated]);

  const handleToggle = () => {
    if (isOpen) {
      setInfoItems(listItemsPaginated);
    } else {
      setInfoItems(carInfoItems);
    }

    setIsOpen(!isOpen);
  };

  return (
    <div className={styles['car-info']}>
      <h2 className={styles.title}>Bilfakta</h2>
      {infoItems ? <WrappedList items={infoItems} /> : null}
      <Button
        type={ButtonType.Button}
        variant={ButtonVariant.GhostInverted}
        size={ButtonSize.Large}
        onClick={handleToggle}
      >
        {isOpen ? 'Visa mindre' : 'Visa mer'}
      </Button>
    </div>
  );
};
